import { postRequest } from '@/core';
import { maintenance } from '@/requests';

export default async function newDeviationTypeRequest(deviationType) {
	let url = maintenance.getDeviationTypesPath();
	let response = await postRequest(url, {}, deviationType);
	return response;
}